import { render } from "./resetPassword.vue?vue&type=template&id=569cc5b3&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=569cc5b3&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569cc5b3"]])

export default __exports__